// extracted by mini-css-extract-plugin
export default {"ellipseEmpty":"checkbox_ellipseEmpty__YrEyG","ellipseFill":"checkbox_ellipseFill__Yck9e"};